import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const LinkFile = styled.div`
    color: ${(props) => props.theme.orange};
    font-size: ${theme.font.size16};
    font-weight: bold;
    text-decoration: underline;
    white-space: normal;
`;
